import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Input, InputNumber, Select, Radio, Col, Row } from 'antd';
import { CheckSquareOutlined, CloseSquareOutlined } from '@ant-design/icons'
import { PickerOverlay } from 'filestack-react';
import { UploadOutlined } from '@ant-design/icons';
import {EditOutlined} from '@ant-design/icons';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
import axios from 'axios';

const { Option } = Select;

const VehicleUpdateForm = ({ visible, onCreate, onCancel, record }) => {
  
  const [form] = Form.useForm();
  let vehicle = record
  const [VehicleID]=useState(vehicle.VehicleID)
  const [AuctionID]=useState(vehicle.AuctionID)
  const [VehicleMPG]=useState(vehicle.VehicleMPG)
  const [VehicleMiles]=useState(vehicle.VehicleMiles)
  const [VehicleStatus]=useState(vehicle.VehicleStatus)
  const [VehicleColor]=useState(vehicle.VehicleColor)
  const [VehicleCondition]=useState(vehicle.VehicleCondition)
  const [VehicleImage]=useState(vehicle.ImageURL)
  const [auctionData, setAuctionData]= useState([])

  
  const [uploadDoneTrigger, setUploadDoneTrigger] = useState(false)
  const [SalesPrice]=useState(vehicle.SalesPrice)
  const [buttonToggle, setButtonToggle] = useState(false)

  useEffect(() => {
    let aipURL = `${FetchVariable.Heroku}/auction/`
    axios.get(aipURL)
    .then((res)=>{
        let data = res.data
        setAuctionData(data)
    })
},[])

  const vColors = ["Red", "Blue", "Green", 
  "Black", "White", "Gray", 
  "Purple", "Yellow", "Gold", 
  "Silver", "N/A"]

  const ImagePicker = () => {
    if (buttonToggle) {
      return (
        <PickerOverlay
          pickerOptions={{
            onClose: () => { setButtonToggle(false); setUploadDoneTrigger(false)}
          }}
          onError={(error) => console.log(error)}
          apikey={"AleCal6RpTNa6OEcJpvEQz"}
          onUploadDone={(res) => {
            setUploadDoneTrigger(true)
            form.setFieldsValue({
              ImageURL: res.filesUploaded[0].url
            })
          }}
        />
      )
    } else {
      return (
        null
      )
    }
  }

  const ImagePickerUploaded = () => {
    if(uploadDoneTrigger === true){
      return(
        <div>
          <CheckSquareOutlined style={{color: 'green', fontSize:'30px', marginTop:'30px'}}/>
        </div>
      )
    }else{
      return (
        <div>
        <CloseSquareOutlined style={{color: 'red', fontSize:'30px', marginTop:'30px'}}/>
      </div>
      )
    }
  }


  return (
    <Modal
      visible={visible}
      title="Update Vehicle"
      okText="Update"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="VehicleUpdate"
        initialValues={{
          VehicleID:VehicleID,
          AuctionID:AuctionID,
          VehicleMPG:VehicleMPG,
          VehicleMiles:VehicleMiles,
          VehicleStatus:VehicleStatus,
          VehicleColor:VehicleColor,
          VehicleCondition:VehicleCondition,
          ImageURL: VehicleImage,
          SalesPrice:SalesPrice,
        }}
      >
        <Form.Item name="VehicleID" label="Vehicle ID">
            <Input disabled/>
        </Form.Item>

        <Row>
          <Col span={12}>
            <Form.Item name="VehicleMPG" label="MPG">
              <InputNumber min={0} max={100} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="VehicleMiles" label="Vehicle Miles">
              <InputNumber min={0} max={1000000} />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item name="VehicleColor" label="Color" style={{width: '175px'}}>
              <Select>
                {vColors?.map(Color=><Option value={Color} key={Color}>{Color}</Option>)}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="AuctionID"
              label="Auction"
            >
              <Select>
                {auctionData?.map(auction => <Option value={auction.AuctionID} key={auction.AuctionID}>{auction.AuctionName}</Option>)}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item name="VehicleCondition" label="Condition">
              <Radio.Group>
                <Radio value="Good">Good</Radio>
                <Radio value="Fair">Fair</Radio>
                <Radio value="Poor">Poor</Radio>
              </Radio.Group>
            </Form.Item>

        <Form.Item name="VehicleStatus" label="Status">
          <Select>
            <Option value="Repair">Needs Repair</Option>
            <Option value="Arriving">Arriving</Option>
            <Option value="ForSale">For Sale</Option>
            <Option value="N/A">N/A</Option>
          </Select>
        </Form.Item>
        <Form.Item name="SalesPrice" label="Sales Price">
          <InputNumber prefix="$" style={{ width: '100%' }} />
        </Form.Item>

        <Row>
          <Col span={10}>
            <Form.Item name='ImageURL' label="Image">
              <Button icon={<UploadOutlined />} onClick={() => setButtonToggle(true)}>
                Click to Upload
                <ImagePicker />
              </Button>
            </Form.Item>
          </Col>
          
          <Col span={12}>
            <ImagePickerUploaded />
          </Col>
        </Row>

      </Form>
    </Modal>
  );
};

const VehicleUpdate = (props) => {
  const [visible, setVisible] = useState(false);
  const onCreate = (values) => {
      props.updateVehicle(values)
    setVisible(false);


  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}
        icon={<EditOutlined />}
      >
      </Button>
      <VehicleUpdateForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
        record={props.record}
      />
    </div>
  );
};

export default VehicleUpdate